import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import i18n from '@/locale';
import { Validator } from 'vee-validate';
import customRules from '@/customRules/rules';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appConfig: [],
  },

  getters: {
    getSiteConfig(state) {
      return state.appConfig;
    },
  },

  mutations: {
    ADD_SITE_CONFIG(state, appConfig) {
      this.state.appConfig = appConfig;
    },
  },

  actions: {
    async getSiteConfig({
      commit,
    }) {
      return new Promise((resolve, reject) => {
        /* Comprobamos que no sea test */
        let MyUrl = window.location.origin;
        if (MyUrl.indexOf('myzone') < 0) {
          MyUrl = 'http://www.mytest.es';
        }
        axios.get(`${MyUrl}/soap.php?act=getDataSite`)
          .then((response) => {
            const langs = response.data.lang;
            i18n.locale = langs;
            Validator.localize(langs, customRules[langs]);
            // console.log(response.data);
            commit('ADD_SITE_CONFIG', response.data);
            resolve(response.data);
          })
          .catch((error) => {
            console.log('Error: ', error); // eslint-disable-line
            reject(error);
          });
      });
    },
  },
});
